/* KitKraft — "Close the Loop". Fill the gap(s) in a circuit with something that
   carries electricity. Levels add a second gap, a switch you control, and
   "which material is the best path". 6 levels, no fail state. No rAF. */
(function () {
  "use strict";

  var IC = {
    copper: '<svg viewBox="0 0 40 40"><rect x="5" y="16" width="30" height="8" rx="2" fill="#e0891f" stroke="#2a2118" stroke-width="2"/><line x1="10" y1="20" x2="30" y2="20" stroke="#b56a10" stroke-width="1.5"/></svg>',
    clip:   '<svg viewBox="0 0 40 40"><path d="M14 9v17a6 6 0 0 0 12 0V12a3.2 3.2 0 0 0-6.4 0v15" fill="none" stroke="#9aa3ad" stroke-width="3.4" stroke-linecap="round"/></svg>',
    coin:   '<svg viewBox="0 0 40 40"><circle cx="20" cy="20" r="12" fill="#f4c542" stroke="#a9791b" stroke-width="2"/><text x="20" y="25" font-size="12" text-anchor="middle" fill="#a9791b" font-family="monospace" font-weight="700">&#8377;</text></svg>',
    key:    '<svg viewBox="0 0 40 40"><circle cx="13" cy="20" r="7" fill="none" stroke="#9aa3ad" stroke-width="3.2"/><path d="M20 20h15M31 20v5M35 20v6" stroke="#9aa3ad" stroke-width="3.2" stroke-linecap="round"/></svg>',
    foil:   '<svg viewBox="0 0 40 40"><path d="M7 12l6 4 7-4 7 4 6-4v17l-6 3-7-3-7 3-6-3z" fill="#dfe3e8" stroke="#2a2118" stroke-width="2" stroke-linejoin="round"/></svg>',
    nail:   '<svg viewBox="0 0 40 40"><path d="M13 8h14l-5 6v18l-2 3-2-3V14z" fill="#9aa3ad" stroke="#2a2118" stroke-width="2" stroke-linejoin="round"/></svg>',
    pencil: '<svg viewBox="0 0 40 40"><path d="M9 31l2-6 15-15 4 4-15 15z" fill="#f4b400" stroke="#2a2118" stroke-width="2" stroke-linejoin="round"/><path d="M26 10l4 4 3-3a2.8 2.8 0 0 0-4-4z" fill="#e0665a" stroke="#2a2118" stroke-width="2"/><path d="M9 31l2-6 4 4z" fill="#2a2118"/></svg>',
    rubber: '<svg viewBox="0 0 40 40"><ellipse cx="20" cy="20" rx="12" ry="7" fill="none" stroke="#e0665a" stroke-width="4.5"/></svg>',
    wood:   '<svg viewBox="0 0 40 40"><rect x="16.5" y="6" width="7" height="28" rx="3.5" fill="#d9a566" stroke="#8a5a2b" stroke-width="2"/></svg>',
    bead:   '<svg viewBox="0 0 40 40"><circle cx="20" cy="20" r="11" fill="#4fa3ff" stroke="#2a2118" stroke-width="2"/><circle cx="20" cy="20" r="3.6" fill="#fff"/></svg>',
    eraser: '<svg viewBox="0 0 40 40"><rect x="7" y="13" width="26" height="13" rx="2.5" fill="#ff9ec4" stroke="#2a2118" stroke-width="2"/><rect x="7" y="13" width="9" height="13" fill="#5a6b8c" fill-opacity=".28"/></svg>',
    crayon: '<svg viewBox="0 0 40 40"><path d="M15 33l3-21a2 2 0 0 1 4 0l3 21z" fill="#b07dff" stroke="#2a2118" stroke-width="2" stroke-linejoin="round"/><line x1="18" y1="14" x2="22" y2="14" stroke="#2a2118" stroke-width="2"/></svg>',
    paper:  '<svg viewBox="0 0 40 40"><path d="M11 6h13l6 6v22H11z" fill="#fff" stroke="#2a2118" stroke-width="2" stroke-linejoin="round"/><path d="M24 6v6h6" fill="none" stroke="#2a2118" stroke-width="2"/></svg>'
  };

  var OBJ = {
    copper: { n: "Copper strip", c: true },
    clip:   { n: "Paper clip",   c: true },
    coin:   { n: "Coin",         c: true },
    key:    { n: "Metal key",    c: true },
    foil:   { n: "Foil",         c: true },
    nail:   { n: "Iron nail",    c: true },
    pencil: { n: "Pencil",       c: true, weak: true },
    rubber: { n: "Rubber band",  c: false },
    wood:   { n: "Lolly stick",  c: false },
    bead:   { n: "Plastic bead", c: false },
    eraser: { n: "Eraser",       c: false },
    crayon: { n: "Crayon",       c: false },
    paper:  { n: "Paper",        c: false }
  };

  var ROUNDS = [
    { out: "bulb", slots: ["C"], sw: false,
      ask: "Drop something in the gap that lets electricity through.",
      win: "The bulb lights up! 💡",
      tray: ["copper", "rubber", "wood", "clip", "bead"] },
    { out: "fan", slots: ["C"], sw: false,
      ask: "Same idea — which one carries the electricity to the motor?",
      win: "The fan spins! 🌀",
      tray: ["coin", "eraser", "foil", "crayon", "key"] },
    { out: "buzzer", slots: ["L", "R"], sw: false,
      ask: "Two gaps now. The loop only works if BOTH are closed.",
      win: "The buzzer sounds! 🔔",
      tray: ["nail", "paper", "clip", "wood", "copper", "bead"] },
    { out: "bulb", slots: ["C"], sw: true,
      ask: "Fill the gap, then flip the switch — a switch is just a gap you control.",
      win: "The lantern glows! 🏮",
      tray: ["foil", "rubber", "key", "crayon", "paper"] },
    { out: "bulb", slots: ["C"], sw: false, quality: true,
      ask: "Any conductor lights it — but some carry electricity better. Find the best path.",
      win: "Bright torch! 🔦",
      tray: ["pencil", "copper", "eraser", "bead", "clip"] },
    { out: "bulb", slots: ["L", "R"], sw: true, quality: true,
      ask: "Everything at once: two gaps, a switch, and only a strong path will do.",
      win: "The lighthouse shines! 🗼",
      tray: ["pencil", "copper", "rubber", "foil", "wood", "crayon"] }
  ];

  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function initOne(root) {
    if (root.dataset.kkloopInit) return;
    root.dataset.kkloopInit = "1";

    var stage = root.querySelector("[data-kkloop-stage]");
    var trayEl = root.querySelector("[data-kkloop-tray]");
    var msgEl = root.querySelector("[data-kkloop-msg]");
    var pipsEl = root.querySelector("[data-kkloop-pips]");
    var sndBtn = root.querySelector("[data-kkloop-snd]");
    var swBtn = root.querySelector("[data-kkloop-switch]");
    var startBtn = root.querySelector("[data-kkloop-start]");
    var againBtn = root.querySelector("[data-kkloop-again]");
    var ctaEl = root.querySelector("[data-kkloop-cta]");
    var winH = root.querySelector("[data-kkloop-win-h]");
    var winP = root.querySelector("[data-kkloop-win-p]");

    var gapEls = {}, bridgeEls = {};
    [].forEach.call(root.querySelectorAll("[data-kkloop-gap]"), function (g) { gapEls[g.getAttribute("data-slot")] = g; });
    [].forEach.call(root.querySelectorAll("[data-bridge]"), function (b) { bridgeEls[b.getAttribute("data-bridge")] = b; });

    // Defensive guard - see kk-sort.js for why (a real "Cannot read properties
    // of null" was seen on the Kit Shelf page, exact game not pinned down).
    if (!stage || !trayEl || !msgEl || !pipsEl || !sndBtn || !swBtn || !startBtn ||
        !againBtn || !ctaEl || !winH || !winP) return;

    ctaEl.textContent = root.getAttribute("data-cta-label") || "See the kits";
    ctaEl.setAttribute("href", root.getAttribute("data-cta-href") || "#");

    var round = 0, busy = false, sndOn = false, ac = null;
    var filled = {}, swClosed = false, flyers = {};

    function beep(freqs, type) {
      if (!sndOn) return;
      try {
        ac = ac || new (window.AudioContext || window.webkitAudioContext)();
        freqs.forEach(function (f, i) {
          var o = ac.createOscillator(), g = ac.createGain();
          o.type = type || "sine"; o.frequency.value = f;
          o.connect(g); g.connect(ac.destination);
          var t0 = ac.currentTime + i * 0.12;
          g.gain.setValueAtTime(0.0001, t0);
          g.gain.exponentialRampToValueAtTime(0.16, t0 + 0.02);
          g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.22);
          o.start(t0); o.stop(t0 + 0.24);
        });
      } catch (e) {}
    }

    sndBtn.addEventListener("click", function () {
      sndOn = !sndOn;
      sndBtn.textContent = sndOn ? "🔊" : "🔈";
      sndBtn.setAttribute("aria-label", sndOn ? "Sound on" : "Sound off");
      if (sndOn) beep([660], "sine");
    });

    function setPips() {
      [].forEach.call(pipsEl.children, function (p, i) {
        p.className = "kkloop__pip" + (i < round ? " done" : i === round ? " now" : "");
      });
    }
    function msg(txt, kind) { msgEl.textContent = txt; msgEl.className = "kkloop__msg" + (kind ? " " + kind : ""); }

    function clearFlyers() {
      [].forEach.call(stage.querySelectorAll(".kkloop__flyer"), function (f) { f.parentNode.removeChild(f); });
      flyers = {};
    }

    function firstEmpty() {
      var s = ROUNDS[round].slots;
      for (var i = 0; i < s.length; i++) if (!filled[s[i]]) return s[i];
      return null;
    }

    function renderRound() {
      var r = ROUNDS[round];
      root.classList.remove("closed", "weak", "swon");
      root.setAttribute("data-out", r.out);
      filled = {}; swClosed = false;
      clearFlyers();

      ["L", "C", "R"].forEach(function (s) {
        var used = r.slots.indexOf(s) >= 0;
        gapEls[s].hidden = !used;
        gapEls[s].classList.remove("filled");
        bridgeEls[s].classList.toggle("on", !used);
      });
      swBtn.hidden = !r.sw;
      swBtn.querySelector(".sl").textContent = "OFF";
      bridgeEls.SW.classList.toggle("on", !r.sw);

      trayEl.innerHTML = "";
      shuffle(r.tray).forEach(function (key) {
        var o = OBJ[key];
        var b = document.createElement("button");
        b.type = "button"; b.className = "kkloop__obj"; b.setAttribute("data-key", key);
        b.innerHTML = IC[key] + '<span class="on">' + o.n + "</span>";
        b.addEventListener("click", function () { pick(key, b); });
        trayEl.appendChild(b);
      });

      msg(r.ask);
      setPips();
      busy = false;
    }

    function pick(key, btn) {
      if (busy || root.classList.contains("closed")) return;
      var slot = firstEmpty();
      if (!slot) {
        if (ROUNDS[round].sw && !swClosed) msg("Both gaps are full — now flip the switch!");
        else msg("The gaps are full.");
        return;
      }
      busy = true;
      var o = OBJ[key];
      var s = stage.getBoundingClientRect();
      var br = btn.getBoundingClientRect();
      var g = gapEls[slot].getBoundingClientRect();

      var fly = document.createElement("div");
      fly.className = "kkloop__flyer";
      fly.innerHTML = IC[key] + '<span class="nm">' + o.n + "</span>";
      fly.style.left = (br.left - s.left + br.width / 2 - 30) + "px";
      fly.style.top = (br.top - s.top) + "px";
      stage.appendChild(fly);

      var dx = (g.left - s.left + g.width / 2 - 30) - (br.left - s.left + br.width / 2 - 30);
      var dy = (g.top - s.top + g.height / 2 - 22) - (br.top - s.top);
      setTimeout(function () { fly.style.transform = "translate(" + dx + "px," + dy + "px)"; }, 20);
      setTimeout(function () { land(key, slot, fly); }, 430);
    }

    function land(key, slot, fly) {
      if (OBJ[key].c) {
        filled[slot] = key;
        flyers[slot] = fly;
        gapEls[slot].classList.add("filled");
        bridgeEls[slot].classList.add("on");
        beep([620], "sine");
        check(true);
      } else {
        fly.classList.add("reject");
        msg("Electricity can’t get through " + OBJ[key].n.toLowerCase() + ". Try another!", "bad");
        beep([180, 140], "square");
        setTimeout(function () {
          if (fly.parentNode) fly.parentNode.removeChild(fly);
          msg(ROUNDS[round].ask);
          busy = false;
        }, 1100);
      }
    }

    function removeFrom(slot) {
      if (flyers[slot] && flyers[slot].parentNode) flyers[slot].parentNode.removeChild(flyers[slot]);
      delete flyers[slot];
      delete filled[slot];
      gapEls[slot].classList.remove("filled");
      bridgeEls[slot].classList.remove("on");
    }

    // tap a filled gap to take the material back out
    ["L", "C", "R"].forEach(function (s) {
      gapEls[s].addEventListener("click", function () {
        if (busy || root.classList.contains("closed") || !filled[s]) return;
        removeFrom(s);
        msg("Took it back out.");
      });
    });

    swBtn.addEventListener("click", function () {
      if (busy || root.classList.contains("closed") || !ROUNDS[round].sw) return;
      swClosed = !swClosed;
      root.classList.toggle("swon", swClosed);
      bridgeEls.SW.classList.toggle("on", swClosed);
      swBtn.querySelector(".sl").textContent = swClosed ? "ON" : "OFF";
      check(false);
    });

    function check(fromLand) {
      var r = ROUNDS[round];
      var done = r.slots.filter(function (s) { return filled[s] && OBJ[filled[s]].c; }).length;
      var allFilled = done === r.slots.length;
      if (!allFilled) {
        busy = false;
        if (r.slots.length > 1 && done > 0) msg("One gap closed — one more to go.");
        else if (r.sw && swClosed) msg("Switch is on — now close the gap.");
        else msg(r.ask);
        return;
      }
      if (r.sw && !swClosed) {
        busy = false;
        msg("The loop is whole — now flip the switch!");
        return;
      }
      var weak = r.quality && r.slots.some(function (s) { return OBJ[filled[s]].weak; });
      if (weak) {
        root.classList.add("closed", "weak");
        msg("Dim! The pencil’s graphite only just carries it — swap in something stronger.", "bad");
        beep([300, 260], "sine");
        setTimeout(function () {
          root.classList.remove("closed", "weak");
          r.slots.forEach(function (s) { if (filled[s] && OBJ[filled[s]].weak) removeFrom(s); });
          msg("Find a stronger path for that gap.");
          busy = false;
        }, 2000);
        return;
      }
      root.classList.add("closed");
      msg(r.win, "good");
      beep([523, 659, 784], "sine");
      setTimeout(nextRound, 2000);
    }

    function nextRound() {
      round++;
      if (round >= ROUNDS.length) return win();
      renderRound();
    }

    function win() {
      setPips();
      root.classList.add("is-won");
      winH.textContent = "You closed every loop! ⚡";
      winP.textContent = "One gap, then two, then a switch, then the best path — that’s the thinking behind every kit on this shelf.";
      againBtn.hidden = false;
      ctaEl.hidden = false;
      try { document.dispatchEvent(new CustomEvent("kk:game-won", { detail: { game: "close-the-loop" } })); } catch (e) {}
    }

    var started = false;
    function begin() {
      if (!started) {
        started = true;
        try { document.dispatchEvent(new CustomEvent("kk:game-start", { detail: { game: "close-the-loop" } })); } catch (e) {}
      }
      round = 0; busy = false;
      root.classList.remove("is-intro", "is-won");
      renderRound();
    }

    startBtn.addEventListener("click", begin);
    againBtn.addEventListener("click", begin);

    document.addEventListener("keydown", function (e) {
      if (busy || root.classList.contains("is-intro") || root.classList.contains("is-won")) return;
      var n = parseInt(e.key, 10);
      if (n >= 1 && n <= 9) { var b = trayEl.children[n - 1]; if (b && !b.disabled) b.click(); }
    });

    root.classList.add("is-intro");
    root.setAttribute("data-out", "bulb");
  }

  function boot() {
    [].forEach.call(document.querySelectorAll(".kkloop[data-kkloop]"), initOne);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.KKCloseLoop = { init: boot };
})();
